/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/wallet'
export default icon
